<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="149" height="51">
    <path class="text" d="M53.1 49.7V37.5H59v-2.9H43.9v2.9h5.8v12.2zm35.6.2V47H80V34.7h-3.2v12.6c0
      1.8.9 2.7 2.7 2.7h9.2zm-15 0V47h-8.8v-3.6h7.6v-2.7h-7.6v-3.1h8.6v-2.9H61.7v12.5c0 1.8.9 2.7
      2.7 2.7h9.3zm-49.7 0v-8.6c0-3.7-.6-7-6.2-7-4.4 0-5.3 1.7-5.6 2.5-.2-.7-1.2-2.5-5-2.5-3.5
      0-4.4 1.1-4.6 1.6H0v13.9h3.4V42c0-4.3 1.2-4.8 3.5-4.8 2.4 0 3.4.7 3.4 4.8v7.8h3.4V42c0-4.3
      1.2-4.8 3.5-4.8s3.5.6 3.5 4.8v7.8H24zm97.8 0v-7.8c0-4.2 1.3-4.8 3.7-4.8 2.5 0 3.7.7 3.7
      4.8v7.8h3.4v-8.5c0-3.7-.9-6.9-6.3-6.9-2.5 0-4.2.2-5.2 1.6h-2.6v13.8h3.3zm26.3
      0V47h-8.8v-3.6h7.5v-2.7h-7.5v-3.1h8.5v-2.9h-11.6v12.5c0 1.8.9 2.7 2.7 2.7h9.2zm-49.4-7.5c0
      5.1 3.4 8.1 8.3 8.1s8.3-3 8.3-8.1-3.4-8.1-8.3-8.1-8.3 3-8.3 8.1m3.5 0c0-3.2 1.7-5.1
      4.9-5.1s4.9 1.8 4.9 5.1c0 3.2-1.7 5.1-4.9 5.1-3.2-.1-4.9-1.9-4.9-5.1m-71.8 0c0-3.4 1.7-5.4
      4.9-5.4s4.9 1.9 4.9 5.4c0 3.4-1.7 5.3-4.9 5.3-3.1 0-4.9-2-4.9-5.3m-3.4 0c0 5.1 3.4 8.1
      8.4 8.1s8.4-3 8.4-8.1-3.4-8.2-8.4-8.2-8.4 3-8.4 8.2" />
    <path class="logo" d="M72.9 21.7c0 7.5 8.8 9.6 14.8 9.6 4.1 0 8.7-.7 13.3-2.4 11.1-4 18.8-11.9
      18.8-18.5 0-7.3-8.1-9.6-14.2-9.6-5.1 0-9.8.9-14 2.5-11 3.9-18.7 11.7-18.7 18.4m6-1.9c0-7.1
      7.7-12.4 13.5-14.5 3-1.1 6-1.7 8.8-1.7 5.2 0 12.7 1.7 12.7 9 0 5-4.5 10.6-11.6 13.4-1
      .4-2.4.8-3.4.8-1.3 0-1.9-.6-1.9-1.5 0-1.1 1.3-4.7 2.4-7.6 1.8-5 3.5-8.4 3.7-9 0-.1.1-.1.1-.2 0
      0 0-.1-.1-.1h-2.8c-3.1 1.6-6.4 2.6-9.8 3-.1 0-.1 0-.1.1l-.8 1.7c-.1.1 0 .1 0 .1 1.4-.1 1.9-.1
      2.1-.1 1.3 0 2.8.1 2.8 1.5 0 .9-.3 2.2-2.7 7.9-1.2 2.8-2.4 5.1-4.9 5.1-4.2 0-8-3.6-8-7.9"/>
  </svg>
</template>

<script>
export default {
  name: 'Logo',
};
</script>

<style lang="scss" scoped>
.text {
  fill: var(--colors-main-font);
}
.logo {
  fill: var(--colors-primary);
}
</style>
